import {createAction} from '@reduxjs/toolkit';

export const setCompareMethod = createAction('SET_COMPARE_METHOD');

export const setCompareSubject = createAction('SET_COMPARE_SUBJECT');

export const setCompareSubjects = createAction('SET_COMPARE_SUBJECTS');

export const swapCompareSubjects = createAction('SWAP_COMPARE_SUBJECTS');

export const clearCompareSubjects = createAction('CLEAR_COMPARE_SUBJECTS');
